import React from 'react';
import { Icon, Tooltip } from '@material-ui/core';
import { PlayerInfoProps } from '@screens/players/types/player.info.props';
import { InfoArea, InfoAreaButton, InfoAreaTitle } from '@screens/players/player.details.tabs/player.info.styles';
import { StatsContainer } from '@screens/players/stats.container';
import { StatRow } from '@screens/players/stat.display';

export const ContactInfo = ({ info }: PlayerInfoProps) => {
  const contact = info.detailContact;
  if (!contact) return null;

  const fullAddress = [contact.address, contact.postCode, contact.city, contact.country].filter((s) => !!s).join(' - ');

  return (
    <InfoArea>
      <InfoAreaTitle>
        Contacts
        <Tooltip title='Edit contact info'>
          <InfoAreaButton aria-label='Edit contact info'>
            <Icon>edit</Icon>
          </InfoAreaButton>
        </Tooltip>
      </InfoAreaTitle>
      <StatsContainer outlined column expandHeight>
        <StatRow label='Email'>{contact.email}</StatRow>
        <StatRow label='Phone'>{contact.phone}</StatRow>
        <StatRow label='Real name'>{contact.name}</StatRow>
        <StatRow label='Address'>{fullAddress}</StatRow>
      </StatsContainer>
    </InfoArea>
  );
};
